import { render, staticRenderFns } from "./ResourceSecondaryFilters.vue?vue&type=template&id=478760f0&"
import script from "./ResourceSecondaryFilters.vue?vue&type=script&lang=js&"
export * from "./ResourceSecondaryFilters.vue?vue&type=script&lang=js&"
import style0 from "./ResourceSecondaryFilters.vue?vue&type=style&index=0&id=478760f0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports